import { userStore } from "../../../stores/user.store";
import { configStore } from "../../../stores/config.store";
import { hooksStore } from "../../../stores/hooks.store";
import { tempStore } from "../../../stores/temp.store";

import {
  getMap,
  pridajVrstvy,
  nastavViditelnostVrstvy,
  sourceExists,
} from "../../../helpers/map";
import {
  editaciaPoznamky,
  ziskajPoznamky,
  zmazPoznamku,
} from "../../../api/poznamky";
import { get as get_store } from "svelte/store";
import get from "get-value";
import { vratVrstvyMapyPodlaTypu } from "../../../helpers/config";
import { Base64 } from "js-base64";

hooksStore.addAction("zmazatPoznamku", "poznamky.func.js", zmazatPoznamku);
hooksStore.addFilter(
  "upravaNastaveniaVrstvy",
  "poznamky.func.js",
  upravFarbuVrstvy
);
hooksStore.addAction("zrusitZormularPoznamky", "poznamky.func.js", zrusit);

export function showHideSelect(event) {
  let open = false;
  // ak klikam na input v otvorenom selecte, tak ho samozrejme nechcem zavriet
  if (
    event.target.closest(".select").classList.contains("js-select--open") &&
    event.target.classList.contains("input")
  ) {
    return;
  }
  // ak kliknuty select nebol otvoreny, tak ho potrebujem otvorit ale az po tom,
  // co zavriem vsetky selecty
  if (!event.target.closest(".select").classList.contains("js-select--open")) {
    open = true;
  }

  // zavriem vsetky selecty
  document.querySelectorAll(".select").forEach((element) => {
    element.classList.remove("js-select--open");
  });

  // otvorim kliknuty select, ak predtym nebol otvoreny a klikol som nanho aby som ho zavrel
  // nastavim focus na vyhladavacie policko
  if (open) {
    event.target.closest(".select").classList.add("js-select--open");
    let select__search = event.target
      .closest(".select")
      .querySelector(".select__search");
    let search_input = event.target
      .closest(".select")
      .querySelector("#vyberVyhladavania");
    if (select__search !== null) {
      select__search.focus();
    } else if (search_input !== null) {
      document.querySelector("#search").focus();
    }
  }
}

export function onDocumentClick(e) {
  if (e.target.closest(".select") === null) {
    // zavriem vsetky selecty
    document.querySelectorAll(".select").forEach((element) => {
      element.classList.remove("js-select--open");
    });
  }
}

export async function zmazatPoznamku(source_id, poznamka_id, popup) {
  const map = getMap();
  const response = await zmazPoznamku(poznamka_id);
  if (response.success) {
    map.getStyle().layers.forEach(function (layer) {
      // ak ma layer spravny source, tak ho vymazem
      if (source_id === layer.source) {
        map.removeLayer(layer.id);
      }
    });

    // ak existuje source ktory mam vymazat
    if (map.getSource(source_id)) {
      map.removeSource(source_id);
    }
    if (popup) {
      popup.remove();
    }
    return true;
  } else {
    return false;
  }
}

export async function zobrazPoznamky(e) {
  const filter = e.target.value;
  const show = e.target.checked;
  const u = userStore.getUser();
  const map = getMap();

  if (show) {
    const data = await ziskajPoznamky(filter);
    if (data.success) {
      data.data.forEach((poznamka) => {
        let source_id = `poznamka_${filter}_${poznamka.id}`;
        for (let i = 0; i < poznamka.layer.features.length; i++) {
          const popupHTML = poznamka.layer.features[i].properties.description;
          const parser = new DOMParser();
          const doc = parser.parseFromString(popupHTML, "text/html");
          const footerButtons = doc.body.querySelector(".footer-buttons");
          /* footerButtons
            .querySelector(".zmazat-poznamku")
            .setAttribute("data-poznamka-id", poznamka.id);
          footerButtons
            .querySelector(".zmazat-poznamku")
            .setAttribute("data-source-id", source_id);
          footerButtons
            .querySelector(".upravit-poznamku")
            .setAttribute("data-poznamka-id", poznamka.id); */
          footerButtons
            .querySelectorAll("[data-poznamka-layer]")
            .forEach((el) => {
              el.setAttribute(
                "data-poznamka-layer",
                Base64.encode(JSON.stringify(poznamka.layer))
              );
            });

          footerButtons.querySelectorAll("[data-poznamka-id]").forEach((el) => {
            el.setAttribute("data-poznamka-id", poznamka.id);
          });

          footerButtons.querySelectorAll("[data-source-id]").forEach((el) => {
            el.setAttribute("data-source-id", source_id);
          });

          if (poznamka.user_id === u.user_id) {
            footerButtons
              .querySelectorAll(
                ".pridat-poznamku, .zobrazit-poznamku, .zavriet-okno"
              )
              .forEach((e) => {
                e.classList.remove("active");
              });

            footerButtons
              .querySelectorAll(
                ".zobrazit-data, .upravit-poznamku, .zmazat-poznamku"
              )
              .forEach((e) => {
                e.classList.add("active");
              });
          } else {
            footerButtons
              .querySelectorAll(
                ".pridat-poznamku, .zobrazit-poznamku, .zavriet-okno, .upravit-poznamku, .zmazat-poznamku"
              )
              .forEach((e) => {
                e.classList.remove("active");
              });

            footerButtons.querySelectorAll(".zobrazit-data").forEach((e) => {
              e.classList.add("active");
            });
          }

          let datumy = document.createElement("p");
          datumy.classList.add("info");
          const datum_vytvorenia = new Date(poznamka.created_at);
          const datum_upravy = new Date(poznamka.updated_at);
          let html = `<br>
              Verejné: ${poznamka.public ? "áno" : "nie"}<br />
              Autor: ${poznamka.user.name}<br />
              Vytvorené: ${datum_vytvorenia.toLocaleDateString("sk-SK", {
                hour: "2-digit",
                minute: "2-digit",
              })}<br />`;
          if (datum_upravy > datum_vytvorenia) {
            html += `Upravené: ${datum_upravy.toLocaleDateString("sk-SK", {
              hour: "2-digit",
              minute: "2-digit",
            })}`;
          }
          datumy.innerHTML = html;
          doc.body.querySelector(".tab-poznamka").append(datumy);

          poznamka.layer.features[i].properties.description =
            doc.body.innerHTML;
        }
        map.addSource(source_id, {
          type: "geojson",
          data: poznamka.layer,
          generateId: true,
          maxzoom: get(get_store(configStore), "layers.maxzoom"),
        });

        for (let i = 0; i < poznamka.layer.features.length; i++) {
          const typ = poznamka.layer.features[i].geometry.type.toLowerCase();
          const vrstvy = vratVrstvyMapyPodlaTypu(typ);
          if (vrstvy) {
            pridajVrstvy(
              typ,
              null,
              false,
              source_id,
              poznamka.layer.features[i].geometry.type,
              i
            );
          }
        }
      });
    }
  } else {
    const zdroje = map.getStyle().sources;
    for (const [key, value] of Object.entries(zdroje)) {
      if (key.startsWith(`poznamka_${filter}_`)) {
        hooksStore.doAction("odstranVrstvuZMapy", key);
      }
    }
  }
}

export function zrusit(source_id_edit, poznamkaId) {
  const map = getMap();
  hooksStore.applyFilters("formReset");
  hooksStore.applyFilters("formMessages", {
    errors: [],
    successes: [],
  });
  hooksStore.doAction("skryFormularNaPoznamku");

  let store = get_store(tempStore);
  const kresleniaKPoznamke = get(store, "kresleniaKPoznamke." + poznamkaId);
  if (kresleniaKPoznamke) {
    kresleniaKPoznamke.forEach((id) => {
      hooksStore.doAction("zmazKonkretneKreslenie", id);
    });
  }

  if (sourceExists(source_id_edit)) {
    const sourceData = map.getStyle().sources[source_id_edit].data;
    for (let i = 0; i < sourceData.features.length; i++) {
      const typ = sourceData.features[i].geometry.type.toLowerCase();
      nastavViditelnostVrstvy(typ, source_id_edit, "visible", i);
    }
  }
}

export async function upravPoznamku(popup, form) {
  const tlacitkoOdoslat = "Ukladanie .";
  let kresleniaKPoznamke = [];
  let count = 0;
  let interval = setInterval(() => {
    if (count % 3 === 0) {
      count = 1;
    } else {
      count++;
    }
    tlacitkoOdoslat = "Ukladanie " + ".".repeat(count);
  }, 300);
  // const csrfResponse = await getCsrf();
  const formData = new FormData(form);
  const data = {};
  for (let field of formData) {
    const [key, value] = field;
    data[key] = value;
  }

  if (get(data, "layer") === "") {
    hooksStore.applyFilters("formMessages", {
      errors: ["Je potrebné zvoliť aspon jedno aktívne kreslenie."],
      successes: [],
    });
    return;
  }

  if (data.id) {
    kresleniaKPoznamke =
      get(get_store(tempStore), `kresleniaKPoznamke.${data.id}`) || {};
  }

  const layerData = JSON.parse(data.layer);
  for (let i = 0; i < layerData.features.length; i++) {
    const popupHTML = layerData.features[i].properties.description;
    const parser = new DOMParser();
    const doc = parser.parseFromString(popupHTML, "text/html");
    const footerButtons = doc.body.querySelector(".footer-buttons");
    footerButtons.querySelector(".pridat-poznamku").classList.remove("active");
    footerButtons.querySelector(".zavriet-okno").classList.remove("active");
    footerButtons.querySelector(".zobrazit-poznamku").classList.add("active");
    doc.body.querySelector(".tab-data").classList.remove("active");
    doc.body.querySelector(".tab-data").innerHTML = "";
    doc.body.querySelector(".tab-poznamka").classList.add("active");
    doc.body.querySelector(".tab-poznamka").innerHTML = `<strong>${
      data.name
    }</strong><p>${data.description.replaceAll("\n", "<br />")}</p>`;
    layerData.features[i].properties.description = doc.body.innerHTML;
    layerData.features[i].properties.title = data.name;
    layerData.features[i].properties.public = data.public;
    layerData.features[i].properties.color = data.color;
    layerData.features[i].properties.note_desc = data.description;
    data.layer = JSON.stringify(layerData);
  }

  let aktiveVsetkyPovodneKreslenia = true;
  if (kresleniaKPoznamke) {
    aktiveVsetkyPovodneKreslenia = kresleniaKPoznamke.every((pid) => {
      return layerData.features.some((l) => l.id === pid);
    });
  }

  if (
    aktiveVsetkyPovodneKreslenia === false &&
    confirm(
      "Jedno alebo viac kreslení, ktoré boli súčasťou editovanej poznámky, nie je teraz zvolené. Chcete uložiť poznámku s aktuálne zvolenými kresleniami?"
    ) === false
  ) {
    return;
  }

  const loginResponse = await editaciaPoznamky(data);
  if (loginResponse.success) {
    hooksStore.applyFilters("formReset");
    if (get(popup, "source_id_parent")) {
      const map = getMap();
      if (map.getSource(popup.source_id_parent)) {
        hooksStore.doAction("odstranVrstvuZMapy", popup.source_id_parent);
      }
    }
    for (let i = 0; i < layerData.features.length; i++) {
      hooksStore.doAction("zmazKonkretneKreslenie", layerData.features[i].id);
    }
    setTimeout(() => {
      hooksStore.applyFilters("formMessages", {
        errors: [],
        successes: [],
      });
      hooksStore.doAction("skryFormularNaPoznamku");
    }, 3000);

    const myPrivate = document.querySelector(
      ".poznamky-vyber input[value='my-private']"
    );
    const myPublic = document.querySelector(
      ".poznamky-vyber input[value='my-public']"
    );
    if (data.public === "1") {
      if (myPublic.checked) {
        myPublic.click();
      }
      setTimeout(() => {
        myPublic.click();
      }, 500);
    } else {
      if (myPrivate.checked) {
        myPrivate.click();
      }
      setTimeout(() => {
        myPrivate.click();
      }, 500);
    }
    if (popup) {
      popup.remove();
    }
  }
  hooksStore.applyFilters("formMessages", {
    errors: loginResponse.errors,
    successes: loginResponse.successes,
  });
  clearInterval(interval);
  tlacitkoOdoslat = "Uložiť";
}

function upravFarbuVrstvy(vrstva, typ, source_id) {
  const map = getMap();
  const source = map.getSource(source_id);
  const color = get(source, "_data.features.0.properties.color");

  if (vrstva.paint && color) {
    Object.keys(vrstva.paint).map(function (key, index) {
      if (key.includes("color") && key.includes("halo") === false) {
        vrstva.paint[key] = color;
      }
    });
  }
  return vrstva;
}
